module.exports = __webpack_public_path__ + "static/media/book-texture2.4a80930a.jpg";